export function getItemImages(item) {
  const images = [];
  const seen = new Set();
  const preview = (item?.image_url || "").trim();
  if (preview) {
    images.push(preview);
    seen.add(preview);
  }
  const more = Array.isArray(item?.image_urls) ? item.image_urls : [];
  for (const raw of more) {
    const value = (raw || "").trim();
    if (!value || seen.has(value)) continue;
    images.push(value);
    seen.add(value);
  }
  return images;
}
